import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayOverlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 78,
	height: 78,
	viewBox: "0 0 78 78",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M62 38.5C62.0015 39.1137 61.8471 39.7174 61.552 40.2523C61.2569 40.7872 60.8311 41.2352 60.3159 41.5526L28.3891 61.4679C27.8508 61.804 27.2343 61.9875 26.6032 61.9994C25.9721 62.0112 25.3494 61.8512 24.7993 61.5357C24.2544 61.225 23.8005 60.772 23.4843 60.2232C23.168 59.6744 23.0009 59.0496 23 58.413V18.5869C23.0009 17.9505 23.168 17.3256 23.4843 16.7768C23.8005 16.228 24.2544 15.775 24.7993 15.4643C25.3494 15.1488 25.9721 14.9887 26.6032 15.0006C27.2343 15.0125 27.8508 15.196 28.3891 15.5321L60.3159 35.4474C60.8311 35.7648 61.2569 36.2128 61.552 36.7477C61.8471 37.2826 62.0015 37.8862 62 38.5Z",
		fill: "#F4F4F4"
	})
});
export default SvgPlayOverlay;
